import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../../i18n'

export const LIST_ITEMS_1 = [
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item1__safetyTipsAndRoadRules
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item2__safetyTipsAndRoadRules
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item3__safetyTipsAndRoadRules
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item4__safetyTipsAndRoadRules
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item5__safetyTipsAndRoadRules
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item6__safetyTipsAndRoadRules
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item7__safetyTipsAndRoadRules
  ),
]

export const LIST_ITEMS_2 = [
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item1__beingAwareOfCommonHazards
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item2__beingAwareOfCommonHazards
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item3__beingAwareOfCommonHazards
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item4__beingAwareOfCommonHazards
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item5__beingAwareOfCommonHazards
  ),
  i18n.t(
    i18nKeys.safetyCourse_bike_step2__au__list_item6__beingAwareOfCommonHazards
  ),
]
